document.addEventListener('change', (event) => {
  const changedInput = event.target;
  if (!changedInput || !changedInput.name) return;

  const form = changedInput.closest('facet-filters-form, #FacetFiltersForm, .facets');
  if (!form) return;

  // Ignore if user changed the availability filter itself
  if (changedInput.name.includes('availability')) return;

  const availabilityInput = form.querySelector('input[name*="availability"]');
  if (availabilityInput && !availabilityInput.checked) {
    availabilityInput.checked = true;
  }
}, true); // capture phase — runs before facets.js's own handler